import { Box, Nav, Shimmer, ShimmerText, VStack } from '@betterment/samba-react';

const ShimmerNavItem = () => (
  <Box
    data-color-mode="dark"
    css={{
      minHeight: '40px',
      fontSize: 'fontSize.50',
      gap: 'space.150',
      display: 'flex',
      alignItems: 'center',
      px: 'space.150',
    }}
  >
    <Shimmer css={{ width: '20px', height: '20px', flexShrink: 0 }} />
    <ShimmerText textStyle="text50" css={{ height: '12px', width: '120px' }} />
  </Box>
);

const SidebarLoadingSkeleton = () => (
  <VStack role="status" aria-busy="true" aria-label="Loading navigation" css={{ gap: 'space.300' }}>
    <Box>
      {/* Overview group: Home, Tasks, 401(k) */}
      <ShimmerNavItem />
      <ShimmerNavItem />
      <ShimmerNavItem />
      <Nav.Separator />
      {/* Tools group: Employees, Payroll, Compliance, Reports */}
      <ShimmerNavItem />
      <ShimmerNavItem />
      <ShimmerNavItem />
      <ShimmerNavItem />
      <Nav.Separator />
      {/* Account and resources group: Help, Resources, Settings */}
      <ShimmerNavItem />
      <ShimmerNavItem />
      <ShimmerNavItem />
    </Box>
  </VStack>
);

export default SidebarLoadingSkeleton;
